import { QaType } from 'lib/types/qualityAssessment.types'
import { MissionHelper } from 'lib/utils/mission.helper'
import { QualityAssessmentHelper } from 'lib/utils/qualityAssessment.helper'

import { useCurrentQaDataForCoworker } from 'hooks/qualityAssssments/useCurrentQaDataForCoworker.hooks'

import { useMissions } from 'state/slices/api'

export const useCurrentSessionData = (coworkerId: string) => {
  const { data: missions = [] } = useMissions(coworkerId)

  const coachingCycleAssessments = useCurrentQaDataForCoworker(coworkerId)?.currentQas ?? []

  const coachingCycleMissions = MissionHelper.getActiveMissions(missions)

  // Resolution
  const resolutionAssessments = QualityAssessmentHelper.filterQasByTopId(
    coachingCycleAssessments,
    QaType.QAR
  )
  const resolutionMissions = MissionHelper.filterMissionsByType(missions, QaType.QAR)

  // Sales
  const salesAssessments = QualityAssessmentHelper.filterQasByTopId(
    coachingCycleAssessments,
    QaType.QAS
  )
  const salesMissions = MissionHelper.filterMissionsByType(missions, QaType.QAS)

  // SAC
  const sacAssessments = QualityAssessmentHelper.filterQasByTopId(
    coachingCycleAssessments,
    QaType.QSA
  )
  const sacnMissions = MissionHelper.filterMissionsByType(missions, QaType.QSA)

  // QBS B2B
  const qbsAssessments = QualityAssessmentHelper.filterQasByTopId(
    coachingCycleAssessments,
    QaType.QBS
  )
  const qbsMissions = MissionHelper.filterMissionsByType(missions, QaType.QBS)

  // QFS
  const qfsAssessments = QualityAssessmentHelper.filterQasByTopId(
    coachingCycleAssessments,
    QaType.QFS
  )
  const qfsMissions = MissionHelper.filterMissionsByType(missions, QaType.QFS)
  return {
    assessments: coachingCycleAssessments,
    missions: coachingCycleMissions,
    resolution: {
      assessments: resolutionAssessments,
      missions: resolutionMissions,
    },
    sales: {
      assessments: salesAssessments,
      missions: salesMissions,
    },
    sac: {
      assessments: sacAssessments,
      missions: sacnMissions,
    },
    qbs: {
      assessments: qbsAssessments,
      missions: qbsMissions,
    },
    qfs: {
      assessments: qfsAssessments,
      missions: qfsMissions,
    }
  }
}
